import React, { useEffect } from 'react';
import Header from '../../../components/Header';
import BackButton from '../../../components/product/BackButton';
import ProductGallery from '../../../components/product/ProductGallery';
import Details from '../../../components/product/Details';
import ProductAttributes from '../../../components/product/ProductAttributes';
import { GET_PRODUCT_WITH_PAGINATION_BY_ID } from '../../../apollo/gql/query/products.query';
import { useQuery } from '@apollo/client';
import { CLOUD_FRONT_URL } from '../../../aws.config';
import { useNavigate, useParams } from 'react-router-dom';
import { scrollToTop } from '../../../lib/utils/utils';
import { useRecoilState, useRecoilValue } from 'recoil';
import { addNewCustomFabricAtom, alankaramDataAtom } from '../../../state';

const ProductDetails: React.FC = () => {
  
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const alankaramData = useRecoilValue(alankaramDataAtom);

  const attributeSections = [
    {
      title: 'Dimensions',
      attributes: [
        { label: 'Size', value: '1850 x 885 x 655 mm' }
      ]
    },
    {
      title: 'Usage',
      attributes: [
        { label: 'Type', value: 'Commercial, Residential' }
      ]
    },
    {
      title: 'Upholstery Color',
      attributes: [
        { label: 'Color', value: 'Pink' }
      ]
    },
    {
      title: 'Seating',
      attributes: [
        { label: 'Capacity', value: '3' }
      ]
    },
    {
      title: 'Production Time Line',
      attributes: [
        { label: 'Days', value: '30-35' }
      ]
    }
  ];

  const initialInput = {
    _id: id,
    companyId: alankaramData?.companyId || "",
  }
    const [addNewCustomFabric, setAddNewCustomFabric] = useRecoilState(addNewCustomFabricAtom)

  const { data } = useQuery(GET_PRODUCT_WITH_PAGINATION_BY_ID, {
    variables: initialInput,
    fetchPolicy: "cache-and-network",
    onError: (error) => {
      setAddNewCustomFabric([]);
      console.log("🚀 ~ error:", error)
      navigate('/products');
    }
  });
  const productData: any = data?.getProductStyleDetailById;

  const productImages = productData ? [
    ...(productData?.detailView ? [{
      id: 0,
      src: CLOUD_FRONT_URL + productData?.detailView,
      alt: productData.name || 'Product Image'
    }] : []),
    {
      id: 1,
      src: 'https://images.pexels.com/photos/1866149/pexels-photo-1866149.jpeg?auto=compress&cs=tinysrgb&w=1260',
      alt: 'Mysig Teakwood Sofa with Orange Leather, front view'
    },
    {
      id: 2,
      src: 'https://images.pexels.com/photos/276583/pexels-photo-276583.jpeg?auto=compress&cs=tinysrgb&w=1260',
      alt: 'Mysig Teakwood Sofa with Orange Leather, angle view'
    },
    {
      id: 3,
      src: 'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1260',
      alt: 'Mysig Teakwood Sofa with Orange Leather, side view'
    },
    {
      id: 4,
      src: 'https://images.pexels.com/photos/3757055/pexels-photo-3757055.jpeg?auto=compress&cs=tinysrgb&w=1260',
      alt: 'Mysig Teakwood Sofa with Orange Leather, close-up detail'
    },
    {
      id: 5,
      src: 'https://images.pexels.com/photos/6585767/pexels-photo-6585767.jpeg?auto=compress&cs=tinysrgb&w=1260',
      alt: 'Mysig Teakwood Sofa with Orange Leather in room setting'
    }
  ] : [];

  const productDetails = {
    title: productData?.name || '',
    code: Boolean(productData?.sku) ? productData?.sku : productData?.uniqueCode,
    designer: {
      name: 'Corey Joseph',
      link: '/designers/corey-joseph'
    },
    categories: [
      { name: 'sofa' },
      { name: '3 seater sofa' }
    ]
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <Header />

      <div className="min-h-screen">

        <div className="px-5">
          <BackButton />
        </div>

        <div className="container mx-auto px-4 md:px-8 py-6">
          <div className="mt-8 flex flex-col md:flex-row gap-12">
            <ProductGallery images={productImages || []} />

            <div className="w-full md:w-1/2 lg:w-2/5">
              <Details
                title={productDetails?.title}
                code={productDetails?.code}
                designer={productDetails?.designer}
                categories={productDetails?.categories}
              />

            </div>
          </div>
        </div>
        <div className="px-5">
          <ProductAttributes sections={attributeSections} />
        </div>
      </div>
    </>
  );
}

export default ProductDetails;